$('body').on('click', '.show-video', function() {
    var vSrc = $(this).data('video-src').match(/(-\d+)_(\d+)/i),
        vOID = vSrc[1],
        vID = vSrc[2],
        iSrc = 'https://vkvideo.ru/video_ext.php?oid='+vOID+'&id='+vID+'&hd=3&autoplay=1&js_api=1';

    $('.pop-up-wrapper.video iframe').attr('src', iSrc)
    showPopUp('video');
})